import { CaseInsensitiveMap } from "Global/Base/DataTypes/CaseInsensitiveMap";
import { ILLFTemplateRenderer, ILLFTemplateRendererRegistrator } from "../LiteListFrame/types";

/**
 * Registrátor, který umožnuje renderery vybírat podle klíče. Nemá metodu `canRender`, renderer se vybírá pouze podle zadaného klíče.
 */
export class KeyRegistrator<RendererType extends ILLFTemplateRenderer = ILLFTemplateRenderer> implements ILLFTemplateRendererRegistrator<RendererType> {
    private _defaultRenderer: RendererType;

    /** Mapa registrovaných rendererů. */
    private _registeredRenderers: CaseInsensitiveMap<RendererType> = new CaseInsensitiveMap<RendererType>();

    constructor(defaultRenderer: RendererType) {
        this._defaultRenderer = defaultRenderer;
        this._registeredRenderers.set(defaultRenderer.key, defaultRenderer);
    }

    public registerFactory(_rendererFactory: () => RendererType): void {
        throw new Error("Method not implemented.");
    }

    public register(renderer: RendererType): void {
        if (!this._registeredRenderers.has(renderer.key)) {
            this._registeredRenderers.set(renderer.key, renderer);
        } else {
            throw new Error(`Renderer with renderer.key="${renderer.key}" is already registred.`);
        }
    }
    public getRendererByKey(key: string): RendererType {
        if (this._registeredRenderers.has(key)) {
            return this._registeredRenderers.get(key) ?? this._defaultRenderer;
        }
        return this._defaultRenderer;
        // Defaultní hodnotu vracím protože TS nedokáže odvodit z mapy, že tento případ je odchycen v předchozím kroku.
    }

    /**
     * Vrací všechny zaregistrované renderery.
     */
    public getAll(): RendererType[] {
        return [
            ...this._registeredRenderers.values(),
            this._defaultRenderer,
        ];
    }
}
